import moment from 'moment';
import { ceil } from 'lodash';

export default function dateStringFromDate(date) {
  const minutesSinceDate = ceil(moment.utc().diff(moment(date), 'minute', true), 0);
  const hoursSinceDate = moment.utc().diff(moment(date), 'hour') || 1;
  const daysSinceDate = moment.utc().diff(moment(date), 'day') || 1;
  const weeksSinceDate = moment.utc().diff(moment(date), 'week') || 1;
  const monthsSinceDate = moment.utc().diff(moment(date), 'month') || 1;
  const yearsSinceDate = moment.utc().diff(moment(date), 'year') || 1;

  if (minutesSinceDate < 59) {
    return `${minutesSinceDate}min`;
  }

  if (hoursSinceDate < 24) {
    return `${hoursSinceDate}h`;
  }

  if (daysSinceDate < 7) {
    return `${daysSinceDate}d`;
  }

  if (weeksSinceDate < 4) {
    return `${weeksSinceDate}w`;
  }

  if (monthsSinceDate < 12) {
    return `${monthsSinceDate}m`;
  }

  return `${yearsSinceDate}y`;
}
